import React from 'react';
import { SparklesIcon, ShieldIcon, HeartIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
export function ValuePropsSection() {
  const ref = useScrollAnimation();
  return <section id="about-us" className="w-full py-20 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-246">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-247">
        {/* Heading */}
        <div className="text-center mb-14 scroll-animate" data-id="element-248">
          <h2 className="font-bold mb-4" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(26px, 4vw, 40px)',
          color: '#0283C7',
          fontWeight: 800,
          lineHeight: 1.1
        }} data-id="element-249">
            Blast Away the Grime, Every Time!
          </h2>
          <p className="max-w-2xl mx-auto" style={{
          color: '#374151',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          lineHeight: 1.65
        }} data-id="element-250">
            Bring out the true beauty of your property with our top-notch power
            washing services.
          </p>
        </div>

        {/* 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-251">
          {/* Col 1 */}
          <div className="scroll-animate flex flex-col items-center text-center p-8 rounded-2xl border-t-4" style={{
          borderTopColor: '#0283C7',
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 24px rgba(2,131,199,0.08)',
          animationDelay: '0s',
          transitionDelay: '0s'
        }} data-id="element-252">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-5" style={{
            backgroundColor: '#E8F4FD'
          }} data-id="element-253">
              <SparklesIcon className="h-8 w-8" style={{
              color: '#0283C7'
            }} data-id="element-254" />
            </div>
            <h3 className="font-bold mb-3" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '20px',
            color: '#0283C7',
            fontWeight: 700
          }} data-id="element-255">
              Enhanced Curb Appeal
            </h3>
            <p style={{
            color: '#374151',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            lineHeight: 1.65
          }} data-id="element-256">
              Instantly boost your property's appearance and value with a fresh,
              clean look.
            </p>
          </div>

          {/* Col 2 */}
          <div className="scroll-animate flex flex-col items-center text-center p-8 rounded-2xl border-t-4" style={{
          borderTopColor: '#0283C7',
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 24px rgba(2,131,199,0.08)',
          transitionDelay: '0.15s'
        }} data-id="element-257">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-5" style={{
            backgroundColor: '#E8F4FD'
          }} data-id="element-258">
              <ShieldIcon className="h-8 w-8" style={{
              color: '#0283C7'
            }} data-id="element-259" />
            </div>
            <h3 className="font-bold mb-3" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '20px',
            color: '#0283C7',
            fontWeight: 700
          }} data-id="element-260">
              Preventative Maintenance
            </h3>
            <p style={{
            color: '#374151',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            lineHeight: 1.65
          }} data-id="element-261">
              Protect and extend the lifespan of your surfaces by preventing
              damage from grime.
            </p>
          </div>

          {/* Col 3 */}
          <div className="scroll-animate flex flex-col items-center text-center p-8 rounded-2xl border-t-4" style={{
          borderTopColor: '#0283C7',
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 24px rgba(2,131,199,0.08)',
          transitionDelay: '0.3s'
        }} data-id="element-262">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-5" style={{
            backgroundColor: '#E8F4FD'
          }} data-id="element-263">
              <HeartIcon className="h-8 w-8" style={{
              color: '#0283C7'
            }} data-id="element-264" />
            </div>
            <h3 className="font-bold mb-3" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '20px',
            color: '#0283C7',
            fontWeight: 700
          }} data-id="element-265">
              Health &amp; Safety
            </h3>
            <p style={{
            color: '#374151',
            fontFamily: 'Inter, sans-serif',
            fontSize: '15px',
            lineHeight: 1.65
          }} data-id="element-266">
              Eliminate harmful grease and residue, reducing slippery surfaces
              and improving safety.
            </p>
          </div>
        </div>
      </div>
    </section>;
}